import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatted = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white py-2 px-4 shadow-lg shadow-red-900/30" data-id="element-63">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-sm md:text-base font-semibold" data-id="element-64">
        <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-65" />
        <span data-id="element-66">🔥 OFERTA EXPIRA EN</span>
        <span className="bg-red-800 px-3 py-0.5 rounded-md font-mono text-base md:text-lg tracking-widest font-bold" data-id="element-67">
          {formatted}
        </span>
        <span className="hidden sm:inline" data-id="element-68">— ¡Aprovechá ahora!</span>
      </div>
    </div>;
}